import './avaxpricing.scss'
import React, { useState, useEffect } from 'react'
import { Button, Container, Grid, Typography } from '@material-ui/core'
import { CheckCircle } from '@material-ui/icons'

const { REACT_APP_STRAPI_API_URL } = process.env
function Avaxpricing() {
  const [makeBetters, setMakeBetter] = useState()
  const getMakeBetterData = async () => {
    const response = await fetch(
      `${REACT_APP_STRAPI_API_URL}/api/bulk-us-betters?populate=Image`
    ).then(response => response.json())
    setMakeBetter(response?.data)
  }
  useEffect(() => {
    getMakeBetterData()
  }, [])

  const [searchDomainTitle, setSearchDomainTitle] = useState()
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${REACT_APP_STRAPI_API_URL}/api/search-domain-titles`
        )
        const json = await response.json()
        setSearchDomainTitle(json?.data[0]?.attributes)
      } catch (error) { }
    }
    fetchData()
  }, [])

  const [bulkDomainName, setBulkDomainName] = useState()
  const getBulkDomainNameData = async () => {
    const response = await fetch(
      `${REACT_APP_STRAPI_API_URL}/api/bulk-domain-names`
    ).then(response => response.json())
    setBulkDomainName(response?.data)
  }
  useEffect(() => {
    getBulkDomainNameData()
  }, [])

  const [bulkDomainContent, setBulkDomainContent] = useState()
  const getBulkDomainContentData = async () => {
    const response = await fetch(
      `${REACT_APP_STRAPI_API_URL}/api/bulk-domain-contents`
    ).then(response => response.json())
    setBulkDomainContent(response?.data)
  }
  useEffect(() => {
    getBulkDomainContentData()
  }, [])

  return (
    <>
      <section className="domainForever">
        <Container>
          <Grid item xs={12}>
            <div className="domainForeverDetail">
              <Typography variant="h1"> Own a domain <span>FOREVER</span> at the best price</Typography>
              <Typography variant="h6">There’s a domain for you with no renewal or expiry.</Typography>
            </div>
          </Grid>
          <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div className="domainForeverRedCard">
                <Typography variant="h5">MOST POPULAR.</Typography>
                <Typography variant="h2">Individual</Typography>
                <Typography component="p">Basic plan with a catchy line here</Typography>
                <Button class="domainForeverButton">BUY NOW</Button>
                <ul className="domainForeverPara">
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                </ul>
              </div>
            </Grid>
            {bulkDomainName &&
              bulkDomainName.map(bulkDomain => (
                <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
                  <div className="domainForeverBlackCard">
                    <Typography variant="h2">{bulkDomain?.attributes.name}</Typography>
                    <Typography component="p">{bulkDomain?.attributes.title}</Typography>
                    <Button class="domainForeverBlackButton">{bulkDomain?.attributes.button}
                    </Button>
                    <ul className="domainForeverPara">
                      {bulkDomainContent &&
                        bulkDomainContent.map(bulkContent => (
                          <li className="domainForeverList">
                            <CheckCircle />
                            {bulkContent?.attributes.content}
                          </li>
                        ))}
                    </ul>
                  </div>
                </Grid>
              ))}
          </Grid>
        </Container>
      </section>
      <section className="domainForever" style={{ display: 'none' }}>
        <Container>
          <Grid item xs={12}>
            <div className="domainForeverDetail">
              <Typography variant="h1"> Own a domain <span>FOREVER</span> at the best price</Typography>
              <Typography variant="h6">There’s a domain for you with no renewal or expiry.</Typography>
            </div>
          </Grid>
          <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div className="domainForeverPurpleCard">
                <Typography variant="h5">MOST POPULAR</Typography>
                <Typography variant="h2">Basic</Typography>
                <Typography component="p">Basic plan with a catchy line here</Typography>
                <Button class="domainForeverPurpleButton">BUY NOW</Button>
                <ul className="domainForeverPara">
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                </ul>
              </div>
            </Grid>
            <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div className="domainForeverBlackCard">
                <h2>Premium</h2>
                <p>Premium plan with a catchy line here</p>
                <Button class="domainForeverBlackButton">
                  <h6>BUY NOW</h6>
                </Button>
                <ul className="domainForeverPara">
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                </ul>
              </div>
            </Grid>
            <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div className="domainForeverBlackCard">
                <h2>Enterprise</h2>
                <p>Ultra plan with a catchy line here</p>
                <Button class="domainForeverBlackButton">
                  <h6>BUY NOW</h6>
                </Button>
                <ul className="domainForeverPara">
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                  <li className="domainForeverList">
                    <CheckCircle />Basic plan with a catchy line here
                  </li>
                </ul>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>
      <section className="makeBetter">
        <Container>
          <Grid item xs={12}>
            <h1>{searchDomainTitle?.usbetterTitle}</h1>
          </Grid>
          <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
            {makeBetters &&
              makeBetters.map(makeBetter => (
                <Grid container item xl={3} lg={3} md={3} sm={12} xs={12}>
                  <div className="makeBetterDetail">
                    <img
                      src={
                        REACT_APP_STRAPI_API_URL +
                        makeBetter?.attributes?.Image?.data[0]?.attributes.url
                      }
                      alt=" "
                      class="img-fluid"
                    />
                    <h2>{makeBetter.attributes.title}</h2>
                    <p>{makeBetter.attributes.content}</p>
                  </div>
                </Grid>
              ))}
          </Grid>
        </Container>
      </section>
    </>
  )
}

export default Avaxpricing
